/* @flow */

import { combineReducers } from 'redux';

import entitiesBraindatesReducer from 'src/shared/domain/braindate/reducer/entitiesBraindatesReducer';
import entitiesConversationsReducer from 'src/shared/domain/conversation/reducer/entitiesConversationsReducer';
import entitiesExpressionOfGratitudeReducer from 'src/shared/domain/expressionOfGratitude/reducer/entitiesExpressionOfGratitudeReducer';
import entitiesEventsReducer from 'src/shared/domain/event/reducer/entitiesEventsReducer';
import entitiesMembershipsReducer from 'src/shared/domain/membership/reducer/entitiesMembershipsReducer';
import entitiesTopicsReducer from 'src/shared/domain/topic/reducer/entitiesTopicsReducer';
import entitiesUsersReducer from 'src/shared/domain/user/reducer/entitiesUsersReducer';
import entitiesLocationsReducer from 'src/shared/domain/location/reducer/entitiesLocationsReducer';
import notificationSliceReducer from 'src/shared/domain/notification/slice/entitiesNotificationSlice';

// $FlowIssue
const entitiesReducer = combineReducers({
  braindates: entitiesBraindatesReducer,
  conversations: entitiesConversationsReducer,
  events: entitiesEventsReducer,
  memberships: entitiesMembershipsReducer,
  topics: entitiesTopicsReducer,
  users: entitiesUsersReducer,
  locations: entitiesLocationsReducer,
  expressionOfGratitude: entitiesExpressionOfGratitudeReducer,
  notifications: notificationSliceReducer,
});

export default entitiesReducer;
